module.exports = __webpack_public_path__ + "img/MTABAPPADBP.d02b8a8d.svg";